module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// /app/~/stream-browserify/~/readable-stream/passthrough.js
// module id = 97
// module chunks = 0